import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SCREEN } from '../../../../../../assets/styles/constants';

export const ColumnWrapper = styled.div`
	border-left: 1px solid rgba(195, 186, 255, 0.4);
	border-top: 1px solid rgba(195, 186, 255, 0.4);
	background-color: #fcfcfc;
	border-radius: 5px;
	overflow: hidden;
	box-shadow: 0 2px 4px 2px rgba(195, 186, 255, 0.1);
	opacity: 0.85;
	display: inline-flex;
	> div:first-child {
		> div {
			width: 50px;
			font-size: 12px;
		}
	}
	
	${props => (props.turn ? 'box-shadow: 0 0px 19px 9px #e5e6fb' : 'box-shadow: 0 0px 19px 9px #ececec')};
`;

const BarItemTopCss = css`
	position: absolute;
	transform: rotate(45deg);
	background: #e0cbd4;
	border-radius: 4px;
	top: 0;
	right: 6px;
	height: 11px;
	width: 2px;
`;

export const CrossBarLeft = styled.div`
	${BarItemTopCss};
`;

export const CrossBarRight = styled.div`
	${BarItemTopCss};
	transform: rotate(-45deg);
`;

export const Cross = styled.div`
	width: 15px;
	height: 13px;
	cursor: pointer;
	position: absolute;
	right: -7px;
	top: -6px;
	background: white;
	z-index: 10000;
	border: 1px solid #e9e6fe;

	:hover > div {
		background: #b0656b;
	}
`;

export const CellsWrapper = styled.div`
	display: inline-grid;
	grid-template-rows: repeat(17, 30px);
	grid-template-columns: auto;
	flex-direction: column;
	gap: 0px;
	grid-row-start: 12;
	.cell-background{
		background-color: rgba(195, 186, 255, 0.4);
	}
	.cell-bold{
		font-weight: bold;
	}
`;
export const CellWrapperResult = styled(CellsWrapper)`
	position: absolute;
	right: -60px;
	width: 60px;
	${SCREEN.MEDIUM} {
		display: none;
	}
	
	& > div {
		${props => (props.turn ? 'box-shadow: 5px 0px 12px 1px #e5e6fb' : 'box-shadow: 5px 0px 12px 1px #ececec')};
		background-color: #f8f8f8;
		font-size: 14px;
		font-weight: bold;
		width: 100%;
		border: 1px solid rgba(195,186,255,0.4);
		position: relative;
		top: -1px;
		height: 31px;
	}
`;

export const Icon = styled(FontAwesomeIcon)`
	font-size: 14px;
	color: #aaaaaa;
	opacity: 0.3;
	
	${props => props.cross && css`
		color: rgba(158, 55, 55, 0.9) !important;
	`}
`;

export const ActiveCell = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	${props => props.active && css`
		background-color: rgba(195, 186, 255, 0.2);
		transition: all 0.2s linear;
		&:hover {
			cursor: pointer;
			box-shadow: inset 0px 0px 10px rgba(195, 186, 255, 1);
			background-color: rgba(195, 186, 255, 0.8);
			${Icon} {
				opacity: 1;
				color: #999999;
			}
		}
	`}
`;

export const Cell = styled.div`
	border-right: 1px solid rgba(195, 186, 255, 0.4);
	border-bottom: 1px solid rgba(195, 186, 255, 0.4);
	border-radius: 1px;
	position: relative;
	display: flex;
	
	align-items: center;
	justify-content: center;
	width: 35px;
	font-size: 14px;
	text-transform: capitalize;

	&:nth-child(8), &:nth-child(11), &:nth-child(17) {
		background-color: #f8f8f8;
		font-size: 14px;
		font-weight: bold;
	}
	${SCREEN.SMALL} {
		// add plus 2 for the first column 
		width: calc(100vw / ${props => props.theme.numberOfColumns + 2})
	}
`;
export const TableHeaderWrapper = styled.div`
	display: none;
	${SCREEN.MEDIUM} {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px !important;
		width: 100%;
		svg {
			color: #7F84FF; 
		}
	}
	
	
`;
